// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1O8SY","requiredAsterisk":"Info_requiredAsterisk__ahXos"};